<template>
	<div class="pages">
		<sub-ibox-title :is-show-back=true><p slot="title">裂变红包</p></sub-ibox-title>
		<section class="menu-edit">
			<div class="m-t-20 w400">
					 <z-input title="红包名称" isMust=true placeholder="" v-model="params.name" maxlength=10></z-input>
					 <div class="p-10 c-g fx shop-tips">
						 <p class="w120 m-r-5"></p>
						 <div class="pic-tips">Tips：红包名称最多10个字符</div>
					 </div>
			</div>
			<div class="fx m-t-20">
				<div class="w120 fx fx-shrink"><i class="ask">*</i><span class="fx-fill">适用门店</span></div>
				<div class="fx-fill m-l-5">
					<label class="fx fx-y-center">
						<input class="b-r-3 m-r-5 checkbox" type="checkbox" @change="handleCheckAll" :checked="isCheckedAll"/>
						<span>全选</span>
					</label>
					<ul class="fx fx-wrap m-t-15">
						<li class="m-r-15 m-b-10" v-for="(item, index) in shopList || []">
							<label class="fx fx-y-center">
								<input class="b-r-3 m-r-5 checkbox" type="checkbox" v-model="item.checked" @change="handleRadioChecked(index)"/>
								<span>{{item.text}}</span>
							</label>
						</li>
					</ul>
				</div>
			</div>
			<div class="fx m-t-20">
				<p class="fx fx-shrink w120 m-t-10"><i class="ask">*</i><span class="fx-fill">发放规则</span></p>
				<div class="m-l-5">
					<div class="fx fx-y-center">消费满
						<p class="w100 m-l-5 m-r-5"><input type="number" class="input b-r-5" name="" id="" value="" v-model="params.send_rule.pay_fee"/></p>元,发放
						<p class="w100 m-l-5 m-r-5"><input type="number" class="input b-r-5" name="" id="" value="" v-model="params.send_rule.count"/></p>个红包。
					</div>
					<div class="p-10 c-g fx shop-tips">
						<!--<p class="w120 m-r-5"></p>-->
						<div class="pic-tips">Tips：消费金额不填写或者填写0则代表支付成功任意金额后都会发放红包。</div>
					</div>
					<div class="fx fx-y-center m-t-10">红包共
						<p class="w100 m-l-5 m-r-5"><input type="number" class="input b-r-5" name="" id="" value="" v-model="params.send_rule.amount"/></p>元，每个红包最少
						<p class="w100 m-l-5 m-r-5"><input type="number" class="input b-r-5" name="" id="" value="" v-model="params.send_rule.single_min_amount"/></p>元，最多
						<p class="w100 m-l-5 m-r-5"><input type="number" class="input b-r-5" name="" id="" value="" v-model="params.send_rule.single_max_amount"/></p>元（随机发放）。
					</div>
				</div>
			</div>
			<div class="fx">
				<p class="fx fx-shrink w120 m-t-10"><span class="fx-fill">使用规则</span></p>
				<div class="fx fx-y-center m-l-5">用户消费满  
					<p class="w100 m-l-5 m-r-5"><input type="number" class="input b-r-5" name="" id="" value="" v-model="params.use_rule"/></p>元可使用。
				</div>
			</div>
			<div class="p-10 c-g fx shop-tips">
				<p class="w120 m-r-5"></p>
				<div class="pic-tips">Tips：用户消费金额不填写或者填写0则代表支付任意金额都能使用。</div>
			</div>
			<!--<div class="fx m-t-20 w500">
				<p class="w120 fx-shrink fx m-t-10"><span class="fx-fill">有效期</span></p>
				<div class="fx-fill m-l-5">
					<el-date-picker
				      v-model="orderTime"
				      type="datetimerange"
				      placeholder="选择时间范围"
				      @change="handleChooseTime">
				    </el-date-picker>
				</div>
			</div>-->
			<!--<div class="w400 m-t-20"><z-input type="tel" title="客服电话" placeholder="请填写客服手机号" v-model="params.service_phone" maxlength = 11></z-input></div>-->
			<div class="m-t-20 w500"><z-input title="使用说明" type="textarea" placeholder="" v-model="params.description"></z-input></div>
			<!--<div class="fx m-t-20">
				<p class="w120 fx-shrink fx"><i class="ask">*</i><span class="fx-fill">是否投放</span></p>
				<div class="fx-fill m-l-5">
					<div class="fx">
						<label class="fx fx-y-center m-r-20">
							<input type="radio" name="switch" id="" class="radio m-r-5 b-r-50" @click="handleStatus" :checked="params.isOpen==1 ? true : false"/>
							<span>是</span>
						</label>
						<label class="fx fx-y-center">
							<input type="radio" name="switch" id="" class="radio m-r-5 b-r-50" @click="handleStatus" :checked="params.isOpen==0 ? true : false"/>
							<span>否</span>
						</label>
					</div>
				</div>
			</div>-->
			<div class="m-t-20 fx">
				<p class="w120 m-r-5 fx-shrink"></p>
				<a class="z-btn z-btn-primary b-r-3" @click="handleValidation">保存</a>
			</div>
		</section>
	</div>
</template>
<style scoped lang="scss">
	@import "src/assets/css/common.scss";
	.c-g{
		color: $color-font-tips;
	}
	.c-f-s{
		color: $color-font-sub;
	}
	.menu-edit {
		background: $color-white;
		border: 1px solid $color-border;
		border-top: none;
		padding: 20px;
		position: relative;
		.vip-droit{
			input[type="text"]{
				width: 140px;
			}
		}
	}
	@media only screen and (min-width:0px) and (max-width:640px) {
		.pages{
			min-width: px-em(1200px);
		}
		.phone-show{
			display: none;
		}
		.menu-edit{
			border: none;
			margin: 0;
			padding: 0;
			&:before{
				display: none;
			}
		}
	}
</style>
<script>
	import { mapActions, mapState } from 'vuex'
	export default {
		name: 'EnvelopeEdit',
		components: {},
		data() {
			return {
				shopList: [],
				orderTime: [],
				params: {
					id: '',
					name: '',
					shopList: [],
					can_use_shops: [],
					send_rule: {
						pay_fee: '', 
						count: '', 
						amount: '', 
						single_min_amount: '', 
						single_max_amount: ''
					},
					use_rule: '',
					description: ''
				},
				isCheckedAll: false,
				shopArrIds: [],
			}
		},
		async mounted() {
			this.params.id = this.$route.query.envelopeId;
			await this.handleGetShopList();
			if(this.$re_Number(this.params.id)) await this.handleEnvelopeInfo();
		},
		computed: {
			...mapState({
				envelopeInfo: state => state.envelope.envelopeInfo,
				shopLists: state => state.shopManage.shopList.list,
			})
		},
		methods: {
			//获取门店列表
			async handleGetShopList() {
				await this.getShopList({count: 10000, offset: 0, search: ''});
                this.shopLists.map((item, index) => {
                		this.shopList.push({value: item.id, text: item.name});
                    this.shopArrIds.push({value: item.id, text: item.name});
                    item.checked = false;
                });
			},
			//处理全选
			handleCheckAll(e) {
				let checked = e.target.checked;
				let shopIdArrTemp = [];
				this.shopList.map((item, index) => {
					item.checked = checked;
					if(item.checked) {
						shopIdArrTemp.push(item.value);
					}
				})
				this.isCheckedAll = checked;
				this.params.can_use_shops = shopIdArrTemp;
			},
			//处理单选
			handleRadioChecked(index) {
				if (this.shopList[index].checked) {
					this.params.can_use_shops.push(this.shopList[index].value);
				} else {
					if (this.isCheckedAll) {
						this.isCheckedAll = false;
					}
					let shopId = this.shopArrIds[index];
					let shopIndex = this.params.can_use_shops.indexOf(shopId);
					this.params.can_use_shops.splice(shopIndex, 1);
				}
			},
			//验证合法性
			handleValidation() {
				if (!this.params.name) return this.$warning('请输入红包名称');
				if (this.params.can_use_shops.length <= 0) return this.$warning('请至少选择一家适用门店');
				if (!this.$re_trueNumber(this.params.send_rule.count)) return this.$warning('请输入合法的发放红包的个数');
				if (!this.$re_twoPoint(this.params.send_rule.amount)) return this.$warning('请输入合法的红包总额，且最多两位小数');
				if (!this.$re_twoPoint(this.params.send_rule.single_min_amount)) return this.$warning('请输入合法的最小红包金额，且最多两位小数');
				if (!this.$re_twoPoint(this.params.send_rule.single_max_amount)) return this.$warning('请输入合法的最大红包金额，且最多两位小数');
				if (parseFloat(this.params.send_rule.single_min_amount) >= parseFloat(this.params.send_rule.single_max_amount)) {
					return this.$warning('最大红包金额必须大于最小红包金额');
				}
				this.handleSave();
			},
			//保存
			async handleSave() {
				try {
					await this.saveEnvelope(this.params);
					this.$success('操作成功');
					this.$back();
				} catch (e) {
					return this.$warning(e);
				}
			},
			//获取红包配置详情
			async handleEnvelopeInfo() {
				try {
					let id = this.params.id;
					this.params = await this.getEnlopeInfo({id: this.params.id});
					this.params.id = id;
					//是否选中全选
					if (this.params.can_use_shops.length == this.shopList.length) {
						this.isCheckedAll = true;
					}
					//选中门店
					this.shopList.map((item, index) => {
						if (this.params.can_use_shops.indexOf(item.value) > -1) {
							this.shopList[index].checked = true;
						}
					});
					this.$log('获取红包配置详情成功');
				} catch (e) {
					return this.$warning(e);
				}
			},
			...mapActions(['getAllShopList', 'getEnlopeInfo', 'getShopList', 'saveEnvelope']),
		},
	}
</script>


// WEBPACK FOOTER //
// RedPacketEditPage.vue?e4e2790a